export default __webpack_public_path__ + "static/media/educate-green.644cdb6c.svg";